/**
 * Display and form constants for console RunsView (badges, filters, add/edit run form options).
 */

export const DAYS = ["Mon", "Tue", "Wed", "Thu", "Fri", "Sat", "Sun"];
export const DAY_ORDER = Object.fromEntries(DAYS.map((d, i) => [d, i]));

export const TYPE_CLASS = {
  easy: "sp-easy",
  long: "sp-long",
  workout: "sp-workout",
  general: "sp-general",
  beginner: "sp-beginner",
};
export const TYPE_LABEL = {
  easy: "Easy/Social",
  long: "Long Run",
  workout: "Workout",
  general: "General",
  beginner: "Beginner",
};
export const EFFORT_CLASS = {
  relaxed: "sp-relaxed",
  moderate: "sp-moderate",
  challenging: "sp-challenging",
};
export const EFFORT_LABEL = {
  relaxed: "Relaxed",
  moderate: "Moderate",
  challenging: "Challenging",
};
export const REL_DOT = {
  anchor: "#3A7A5C",
  regular: "#7DC89A",
  occasional: "#D4922A",
  unverified: "#B5B0A5",
};
export const REL_LABEL = {
  anchor: "Anchor",
  regular: "Regular",
  occasional: "Occasional",
  unverified: "Unverified",
};

/** Cap height so very long notes scroll inside the modal instead of stretching it endlessly. */
export const WHAT_TO_EXPECT_TEXTAREA_MAX_PX = 560;

export function syncWhatToExpectTextareaHeight(el) {
  if (!el) return;
  el.style.height = "auto";
  const sh = el.scrollHeight;
  const capped = Math.min(sh, WHAT_TO_EXPECT_TEXTAREA_MAX_PX);
  el.style.height = `${capped}px`;
  el.style.overflowY = sh > WHAT_TO_EXPECT_TEXTAREA_MAX_PX ? "auto" : "hidden";
}

/** Publish workflow statuses (stored in meeting.status). Lifecycle statuses (upcoming, completed, cancelled) are treated as visible. */
export const WORKFLOW_STATUSES = ["draft", "review", "published", "archived"];
export const WORKFLOW_LABEL = {
  published: "Published",
  draft: "Draft",
  review: "Needs Review",
  candidate: "Candidate",
  archived: "Archived",
  upcoming: "Upcoming",
  completed: "Completed",
  cancelled: "Cancelled",
};
/** Status values that have dedicated badge styles (ps-*) in console.css */
export const STATUS_BADGE_VARIANTS = new Set(["draft", "review", "published", "archived", "candidate", "upcoming", "completed", "cancelled"]);

/** Derive workflow status for display: one of draft/review/published/archived. Lifecycle status (upcoming/completed) => "published". */
export function getWorkflowStatus(meeting) {
  const s = meeting?.status;
  return s && WORKFLOW_STATUSES.includes(s) ? s : "published";
}

/** Run types (event_type) — same as mobile create run. */
export const RUN_TYPES = [
  { value: "Easy / Social", label: "Easy / Social" },
  { value: "Training-Focused", label: "Training-Focused" },
];
/** Effort (difficulty) — display label -> backend value. */
export const EFFORT_OPTIONS = [
  { value: "Relaxed", backend: "easy" },
  { value: "Moderate", backend: "steady" },
  { value: "Challenging", backend: "spicy" },
];
export const SURFACE_OPTIONS = [
  { value: "road", label: "Road" },
  { value: "track", label: "Track" },
  { value: "trail", label: "Trail" },
  { value: "other", label: "Other" },
];
export const REL_OPTIONS_CREATE = [
  { value: "unverified", label: "? Unverified" },
  { value: "regular", label: "✓ Regular" },
  { value: "occasional", label: "~ Occasional" },
  { value: "anchor", label: "⚓ Anchor" },
];

export const PACE_PILLS_MAX = 2;
